module.exports = __webpack_public_path__ + "static/media/MAG.68cf6230.mp4";